export default __webpack_public_path__ + "static/media/figma.532313dc.png";